import './pricelist-pdf.scss';
